export default {
  en: {
    login: "Sign In",
    username: "Username",
    password: "Password",
    loginbtn: "Sign In",
    welcometitle: "Welcome to the PlantM",
    welcomemessage: "Real-time production data monitoring with Overall Equipment Effectiveness (OEE) evaluation",
    dashboard: "Dashboard",
    siteManagement: "Site Management",
    machinesAnalytics: "Machines Analytics",
    machines: "Machines",
    maintenance: "Maintenance",
    configuration: "Configuration",
    userNameDisplay: "John Doe",
    performanceValue: "Performance",
    availabilityValue: "Availability",
    qualityValue: "Quality",
    oee: "Overall Equipment Effectiveness (OEE)",
    idNova: "ID Nova",
    version: "Version",
    webPlantM: "Web Plant M",
    lastUpdated: "Last Updated",
    noDataFound: "No data found for",
    machineDataRefreshed: "Machine data refreshed",
    welcomeBack: "Welcome back",
    dashboardIntro: "We're glad to see you again. Here's a quick overview of your dashboard.",
    lastOeeValues: "Last OEE Values by Machine",
    oeePerShift: "OEE per Shift (%)",
    error: {
      fillAllFields: "Please fill in all fields",
      invalidCredentials: "Incorrect username or password"
    },
    oeeChart: {
      title: "OEE values of each machine for the last 5 shifts"
    },
    averageOeeTitle: "Average OEE",
    barChartTitle: "OEE over 5 recent shifts"
  },
  ru: {
    login: "Войти в систему",
    username: "Имя пользователя",
    password: "Пароль",
    loginbtn: "Войти",
    welcometitle: "Добро пожаловать в PlantM",
    welcomemessage: "Онлайн-мониторинг производственных данных с оценкой эффективности использования оборудования (OEE)",
    dashboard: "Панель управления",
    siteManagement: "Управление сайтом",
    machinesAnalytics: "Аналитика машин",
    machines: "Оборудование",
    maintenance: "Обслуживание",
    configuration: "Конфигурация",
    userNameDisplay: "Джон Доу",
    performanceValue: "Производительность",
    availabilityValue: "Доступность",
    qualityValue: "Качество",
    oee: "Коэффициент эффективности использования оборудования (OEE)",
    idNova: "ID Нова",
    version: "Версия",
    webPlantM: "Веб Платформа M",
    lastUpdated: "Последнее обновление",
    noDataFound: "Данные не найдены для",
    machineDataRefreshed: "Данные машины обновлены",
    welcomeBack: "С возвращением",
    dashboardIntro: "Рады видеть вас снова. Вот краткий обзор вашей панели.",
    lastOeeValues: "Значения OEE оборудования за последнюю смену",
    oeePerShift: "OEE за смену (%)",
    error: {
      fillAllFields: "Пожалуйста, заполните все поля",
      invalidCredentials: "Неверное имя пользователя или пароль"
    },
    oeeChart: {
      title: "Значения OEE каждого оборудования за последние 5 смен"
    },
    averageOeeTitle: "Средний OEE",
    barChartTitle: "OEE за последние 5 смен"
  },
  et: {
    login: "Logi sisse",
    username: "Kasutajanimi",
    password: "Parool",
    loginbtn: "Logi sisse",
    welcometitle: "Tere tulemast PlantMi",
    welcomemessage: "Tootmisandmete reaalajas jälgimine koos seadmete kasutustõhususe (OEE) hindamisega",
    dashboard: "Avaleht",
    siteManagement: "Saidihaldus",
    machinesAnalytics: "Masinate analüüs",
    machines: "Masinad",
    maintenance: "Hooldus",
    configuration: "Seadistused",
    userNameDisplay: "John Doe",
    performanceValue: "Tõhusus",
    availabilityValue: "Saadavus",
    qualityValue: "Kvaliteet",
    oee: "Seadmete kasutustõhusus (OEE)",
    idNova: "ID Nova",
    version: "Versioon",
    webPlantM: "Veebiplant M",
    lastUpdated: "Viimati uuendatud",
    noDataFound: "Andmeid ei leitud masina jaoks",
    machineDataRefreshed: "Masina andmed on uuendatud",
    welcomeBack: "Tere tulemast tagasi",
    dashboardIntro: "Rõõm sind taas näha. Siin on kiire ülevaade sinu töölauast.",
    lastOeeValues: "Viimased OEE väärtused masinate kaupa",
    oeePerShift: "OEE väärtus vahetuse kohta",
    error: {
      fillAllFields: "Palun täitke kõik väljad",
      invalidCredentials: "Vale kasutajanimi või parool"
    },
    oeeChart: {
      title: "OEE väärtused viimase 5 vahetuse kohta iga masina jaoks"
    },
    averageOeeTitle: "Keskmine OEE",
    barChartTitle: "OEE viimase 5 vahetuse kohta",
  },
};